module.exports = __webpack_public_path__ + "img/remainder1.faa8b9b1.svg";